import { getAPIURL } from '@utils/api'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { LidCodeOverview } from '@api/useTankLidCodes/response'
import type { LidCodeUpsertRequest } from '@api/useTankLidCodes/request'

export const useTankLidCodes = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const useLidCodeOverview = () =>
    useQuery({ queryKey: ['lidCodeOverview'], queryFn: (): LidCodeOverview => api.post('tank_lid_code/overview') })

  const useLidCodeByIdQuery = () =>
    useQuery({ queryKey: ['lidCodeById'], queryFn: () => api.post('tank_lid_code/by_id') })

  const useLidCodeDeleteMutation = useMutation({
    mutationKey: ['lidCodeDelete'],
    mutationFn: (id: string) => api.post('tank_lid_code/delete', {}, { queryParams: new URLSearchParams({ id }) }),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: ['lidCodeOverview'],
      }),
  })

  const useLidCodeUpsertMutation = useMutation({
    mutationKey: ['lidCodeUpsert'],
    mutationFn: ({ name, color, tank_lid_id, image }: LidCodeUpsertRequest) =>
      api.post('tank_lid_code/upsert', image ?? { image: null }, {
        queryParams: new URLSearchParams({ name, color }),
      }),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: ['lidCodeOverview'],
      }),
  })

  return { useLidCodeOverview, useLidCodeByIdQuery, useLidCodeDeleteMutation, useLidCodeUpsertMutation }
}
